import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { AddCompanyModalContainer } from './styled'
import { getBusinessGroups, getBPCompanies } from 'ducks/vendorMaintenance'
import { getCompanies } from 'ducks/options'
import CompanyCell from './CompanyCell'
import BusinessGroupCell from './BusinessGroupCell'

import r from 'reactotron-react-js'

const CompanyModal = (props) => {
  const { valueForm, change, handleSubmit, onSubmitCompanies, showCompanyModal, 
    vendorCode, selectedCompany, businessGroups, vendorCompanies, companyOptions } = props

  const [showBusinessGroup, setBusinessGroup] = useState(true)
  r.log({ businessGroups })

  useEffect(() => {
    if (vendorCompanies.vendorCode !== vendorCode) {
      if (vendorCompanies.data.length === 0 && vendorCompanies.loading === false) {
        props.getBPCompanies(vendorCode)
      }
    }

    if (businessGroups.data.length === 0 && businessGroups.loading === false) {
      props.getBusinessGroups()
    }

    if (companyOptions.data.length === 0 && companyOptions.loading === false) {
      props.getCompanies()
    }

  }, [])
  
  const submitCompanies = (values) => {
    onSubmitCompanies(values.companies || [])
    showCompanyModal(false)
  }

  const companyIsActiveInSAP = (value) => {
    return vendorCompanies.data.find(a => a.value === value) !== undefined
  }

  const companyIsSelected = (value) => {
    return (valueForm.companies || []).includes(value) || (value === selectedCompany)
  }

  const onClickBusinessGroup = (value) => {
    var companies = []

    value.forEach(c => {
      if (!companyIsActiveInSAP(c)) {
        companies.push(c)
      }
    });

    change('companies', companies)
  }

  return (
    <Dialog open={true} maxWidth='md' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Select Company</DialogTitle>
      <DialogContent>
        <form>
          <AddCompanyModalContainer>
            {
              businessGroups.data.length > 0 ?
                <div className='businessGroupSection'>
                  <div className='subTitle'>Select by Business Group</div>
                  <div className='cellSection'>
                    {
                      showBusinessGroup ? 
                        businessGroups.data.map(b => 
                          b.businessGroup === '-' ? null :
                          <BusinessGroupCell 
                            title={b.businessGroup} 
                            companyCodes={b.companyCodes || []} 
                            onClick={onClickBusinessGroup}
                          />
                        ) : null
                    }
                  </div>
                </div> : null
            }
            <div className='companiesSection'>
            <div className='subTitle'>
              <div className='leftPanel'>
                Select by company
                <div className={`counting ${(valueForm.companies || []).length > 0 ? 'blue' : 'red'}`}>
                  {` (${(valueForm.companies || []).length} ${(valueForm.companies || []).length > 1 ? 'Companies' : 'Company'} Selected.)`}
                </div>
              </div>
              <div className='clearButton' onClick={()=> { change('companies', []) }}>
                Clear All
              </div>
            </div>
              <div className='cellSection'>
                {
                  companyOptions.data.map(c => {
                    return (
                      <CompanyCell 
                        title={c.text} 
                        value={c.value} 
                        disable={companyIsActiveInSAP(c.value)} 
                        selected={companyIsSelected(c.value) || companyIsActiveInSAP(c.value)}
                        onClick={(value) =>{
                          if (!companyIsActiveInSAP(c.value)) {
                            var data = [...valueForm.companies]
                            if (companyIsSelected(c.value)) {
                              data.splice(data.indexOf(c.value), 1)
                            } else {
                              data.push(c.value)
                            }
                            change('companies', data)
                          }
                        }}
                      />
                    )
                  })
                }
              </div>
            </div>
          </AddCompanyModalContainer>
        </form>
      </DialogContent>
      <DialogActions>
        <form onSubmit={handleSubmit(values => submitCompanies(values))}>
          <Button
            color='blue'
            content='Confirm'
            type='submit'
          />
          <Button
            color='red'
            content='Cancel'
            onClick={() => showCompanyModal(false)}
          />
        </form>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const companyData = props.companyData || []
  return ({
    valueForm: getFormValues('formCompany')(state) || {},
    initialValues: {
      companies: companyData
    },
    businessGroups: state.vendorMaintenance.businessGroups,
    vendorCompanies: state.vendorMaintenance.vendorCompanies,
    companyOptions: state.options.companies,
  })
}
  
const mapDispatchToProps = {
  getBusinessGroups,
  getBPCompanies,
  getCompanies
}

const CompanyModalForm = reduxForm({
  form: 'formCompany',
  enableReinitialize: true
})(CompanyModal)

export default connect(mapStateToProps, mapDispatchToProps)(CompanyModalForm)